import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAuth } from "@/contexts/AuthContext";
import { Building2 } from "lucide-react";

export function ChainHospitalPicker() {
  const { user, activeHospitalId, switchHospital, isChainAdmin } = useAuth();
  const hospitals = user?.hospitals ?? [];

  if (!isChainAdmin || hospitals.length === 0) return null;

  const current = hospitals.find((h) => h.id === activeHospitalId);

  return (
    <div className="flex items-center gap-2 mr-4">
      <Building2 className="h-4 w-4 text-white/80 shrink-0" />
      <Select
        value={activeHospitalId ?? undefined}
        onValueChange={(id) => void switchHospital(id)}
      >
        <SelectTrigger className="h-9 w-[200px] bg-white/10 border-white/20 text-white text-sm">
          <SelectValue placeholder="Select hospital">
            {current?.name ?? "Select hospital"}
          </SelectValue>
        </SelectTrigger>
        <SelectContent>
          {hospitals.map((h) => (
            <SelectItem key={h.id} value={h.id}>
              {h.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
